import { writable } from 'svelte/store';

export const buyersList =  writable([]);
export const buyersListFull =  writable([]);

